import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {OAuthService} from "angular-oauth2-oidc";
import {Customer} from "../_models/Customer";

@Injectable({providedIn: 'root'})
export class CustomerService {

  constructor(private httpClient: HttpClient, private oauthService: OAuthService) {
  }

  getCustomersByUser() {
    return this.httpClient.get<Customer[]>('/api/customers/customersbyuser');
  }

  getCustomerById(id: number) {
    return this.httpClient.get<Customer[]>('/api/customers');
  }
}
